module.exports = __webpack_public_path__ + "static/media/price_free.729b089d.png";